import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { preventDefault } from '../../../utils/events'
import Button from '../../Button'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../Icon'
import { QA_NAME_TAG_REMOVE } from '../Tag.constants'
import { getTagActionSize, isTagAppearanceFilled } from '../Tag.utils'

import * as styles from './TagRemoveControl.module.css'

import CloseIcon from '../../../icons/close.svg'
import DeleteIcon from '../../../icons/delete.svg'

function TagRemoveControl({
  appearance,
  height,
  qaName = QA_NAME_TAG_REMOVE,
  ref,
  tooltipKey,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  onClick,
}) {
  const { t } = useTranslation()

  return isTagAppearanceFilled(appearance) ? (
    <IconWithTooltip
      Icon={CloseIcon}
      className={styles.closeIcon}
      qaContext={null}
      qaName={qaName}
      ref={ref}
      size={ICON_HEIGHT_16}
      tooltip={t(tooltipKey || 'Select.TagClearTooltipKey')}
      tooltipPlacement={tooltipPlacement}
      onClick={onClick}
      onMouseDown={preventDefault}
    />
  ) : (
    <Button.Outlined
      isGrey
      beforeIconProps={{ Icon: DeleteIcon }}
      height={getTagActionSize(height)}
      qaName={qaName}
      tooltip={t(tooltipKey || 'Tag.DeleteBtnTooltipKey')}
      tooltipPlacement={tooltipPlacement}
      onClick={onClick}
      onMouseDown={preventDefault}
    />
  )
}

export default TagRemoveControl
